// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface GenderMaleIconSignature {
  Element: SVGSVGElement;
}

export const GenderMaleIcon: TOC<GenderMaleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.001 5V3H21.001V11H19.001V6.414L13.886 11.529C14.585 12.51 15.001 13.706 15.001 15C15.001 18.309 12.31 21 9.00101 21C5.69201 21 3.00101 18.309 3.00101 15C3.00101 11.691 5.69201 9 9.00101 9C10.295 9 11.491 9.416 12.472 10.115L17.587 5H13.001ZM5.00101 15C5.00101 17.206 6.79501 19 9.00101 19C11.207 19 13.001 17.206 13.001 15C13.001 12.795 11.207 11 9.00101 11C6.79501 11 5.00101 12.795 5.00101 15Z"/>
</svg>
</template>;